<body class="horizontal-layout horizontal-menu 1-column  bg-full-screen-image blank-page blank-page"
    data-open="hover" data-menu="horizontal-menu" data-col="1-column">
    <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">
            <div class="content-header row">
            </div>
            <div class="content-body">
                <section class="row flexbox-container">
                    <div class="col-12 d-flex align-items-center justify-content-center">
                        <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
                            <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
                                <div class="card-header border-0 pb-0">
                                    <div class="card-title text-center">
                                        <img src="/assets/images/logo-dark.png" alt="branding logo">
                                        <br><br>
                                    </div>
                                </div>
                                <div *ngIf="!verified" class="card-content">
                                    <p class="card-subtitle line-on-side text-muted text-center font-small-3 mx-2 my-1">
                                        <span>Setup Password For Your Account</span>
                                    </p>
                                    <div class="card-body">
                                        <form class="form-horizontal">
                                            <fieldset class="form-group position-relative has-icon-left mb-0">
                                                <input type="password" class="form-control" id="password"
                                                    name="password" placeholder="Your Password" [(ngModel)]="password"
                                                    #Password="ngModel" minlength="8" required>
                                                <div class="form-control-position">
                                                    <i class="fa fa-key"></i>
                                                </div>
                                                <span class="text-danger"
                                                    *ngIf="(Password.errors && Password.errors['minlength'] || Password.invalid) && Password.touched">*
                                                    Password
                                                    must be at least 8 characters long.
                                                </span>
                                            </fieldset>
                                            <fieldset class="form-group position-relative has-icon-left">
                                                <input type="password" class="form-control" id="user-password"
                                                    name="user-password" placeholder="Confirm Password"
                                                    [(ngModel)]="confirmPassword" #ConfirmPassword="ngModel" required
                                                    (keyup.enter)="Submit()">
                                                <div class="form-control-position">
                                                    <i class="fa fa-key"></i>
                                                </div>
                                                <span class="text-danger"
                                                    *ngIf="(ConfirmPassword.errors && ConfirmPassword.errors['minlength'] || ConfirmPassword.invalid) && ConfirmPassword.touched">*
                                                    Password
                                                    must be at least 8 characters long.
                                                </span>
                                            </fieldset>
                                            <button type="button" class="btn btn-outline-primary btn-block"
                                                (click)="Submit()">
                                                <i class="feather icon-unlock"></i>
                                                Submit
                                            </button>
                                        </form>
                                    </div>
                                </div>

                                <div *ngIf="verified" class="card-content">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="confirmation text-center">
                                                <h4 class="text-success">Already Verified!</h4>
                                                <br />
                                                <p> You have already verified your email.<br />
                                                    Kindly wait for your account to be approved by Mathecad Team.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</body>
